export interface IVtoWindow extends Window {
    MSStream: unknown;
}

declare let window: IVtoWindow;

const userAgent = navigator.userAgent;

export const isIOS = () => {
    return /iPad|iPhone/.test(userAgent) && !window.MSStream;
};

export const isUserMediaEnabled = () => {
    return !!navigator.mediaDevices?.getUserMedia;
};

export const isSafari = () => {
    return (
        /safari/i.test(userAgent) &&
        !/chrome/i.test(userAgent) &&
        !/crios/i.test(userAgent) &&
        !/fxios/i.test(userAgent)
    );
};
